import React, { useState, useEffect, useRef } from 'react';
import { useTheme } from '@mui/material/styles';
import {
  ClickAwayListener,
  Divider,
  Grid,
  Paper,
  Popper,
  Stack,
  Typography,
  useMediaQuery
} from '@mui/material';
import PerfectScrollbar from 'react-perfect-scrollbar';
import NotificationList from './notificationList';
import Transitions from './transition';
import MainCard from './mainCard';
import { getNotifications, markNotificationsAsRead } from '../../api/Notification';
import { useDispatch, useSelector } from 'react-redux';
import { failed } from '../../utils/Tostify';

const NotificationSection = ({ open, onClose, anchorEl, type, getNotificationCount }) => {
  const theme = useTheme();
  const matchesXs = useMediaQuery(theme.breakpoints.down('md'));
  const [notifications, setNotifications] = useState([]);
  const user = useSelector((state) => state.userReducer.user);
  const token = useSelector(state => state.userReducer.token);
  const dispatch = useDispatch();
  const hasRead = useRef(false);
  const userRole = localStorage.getItem("userRole");
  const currentClinicId = localStorage.getItem("currentHospitalId");

  const fetchNotifications = async () => {
    try {
      const res = await getNotifications({ userId: user._id, values: { type }, dispatch, token, userRole,currentClinicId  });
      if (res?.status === 'SUCCESS') {
        setNotifications(res?.data);
      } else {
        failed(res?.message);
      }
    } catch (error) {
      failed('Failed to fetch notifications.');
    }
  };

  const handleMarkAsRead = async () => {
    if (!hasRead.current) {
      hasRead.current = true;
      await markNotificationsAsRead({ userId: user._id, type, dispatch, userRole, currentClinicId});
      await getNotificationCount();
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  const handleClose = () => {
    handleMarkAsRead();
    onClose();
    return () => {
      handleMarkAsRead();
    };
  };

  return (
    <Popper
      placement={matchesXs ? 'bottom' : 'bottom-end'}
      open={open}
      anchorEl={anchorEl}
      role={undefined}
      transition
      disablePortal
      popperOptions={{
        modifiers: [
          {
            name: 'offset',
            options: { offset: [matchesXs ? 5 : 0, 20] }
          }
        ]
      }}
    >
      {({ TransitionProps }) => (
        <Transitions position={matchesXs ? 'top' : 'top-right'} in={open} {...TransitionProps}>
          <Paper sx={{ minWidth: 400, maxWidth: 400 }}>
            <ClickAwayListener onClickAway={handleClose}>
              <MainCard border={false} elevation={16} content={false} boxShadow shadow={theme.shadows[16]}>
                <Grid container direction="column" spacing={2}>
                  <Grid item xs={12}>
                    <Grid container alignItems="center" justifyContent="space-between" sx={{ pt: 2, px: 2 }}>
                      <Grid item>
                        <Stack direction="row" spacing={2}>
                          <Typography variant="subtitle1">All Notification</Typography>
                        </Stack>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <PerfectScrollbar style={{ overflowX: 'hidden' }}>
                      <NotificationList notifications={notifications} />
                    </PerfectScrollbar>
                  </Grid>
                </Grid>
                <Divider />
              </MainCard>
            </ClickAwayListener>
          </Paper>
        </Transitions>
      )}
    </Popper>
  );
};

export default NotificationSection;
